/* LVC: update visible sticky product context from the same variant event as the product form.
   Does not add to cart, override form validation, or synthesize clicks. */
(function(){'use strict';
  function update(variant){
    if(!variant)return;
    document.querySelectorAll('sticky-cart-modal .lvc-sticky-meta').forEach(function(meta){
      var label=meta.querySelector('.lvc-sticky-meta__variant');
      var price=meta.querySelector('.lvc-sticky-meta__price');
      if(label && variant.title)label.textContent=variant.title;
      if(price && typeof variant.price==='number'){
        try { price.textContent=new Intl.NumberFormat(document.documentElement.lang || 'es-ES',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(variant.price/100); } catch(e){}
      }
    });
  }
  function ready(){
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.variantChange,function(e){update(e && e.data && e.data.variant);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
